import PropTypes from 'prop-types';

export const breadcrumbType = PropTypes.shape({
    label: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
});

export const pageDataType = PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.shape({
        id: PropTypes.string,
    }),
]);

export const imageType = PropTypes.shape({
    id: PropTypes.number,
    src: PropTypes.string,
    srcset: PropTypes.arrayOf(
        PropTypes.shape({
            jpg: PropTypes.string,
            size: PropTypes.string,
            webp: PropTypes.string,
        }),
    ),
});

export const menuSubItemType = PropTypes.shape({
    label: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
});

export const menuItemType = PropTypes.shape({
    icon: PropTypes.string,
    label: PropTypes.string.isRequired,
    link: PropTypes.string,
    subItems: PropTypes.arrayOf(menuSubItemType),
});
